import { render, staticRenderFns } from "./public-footer.vue?vue&type=template&id=288847dd&scoped=true&"
import script from "./public-footer.ts?vue&type=script&lang=ts&"
export * from "./public-footer.ts?vue&type=script&lang=ts&"
import style0 from "./public-footer.scss?vue&type=style&index=0&id=288847dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288847dd",
  null
  
)

export default component.exports